import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportAccountsPayable } from './AccountsPayable.service';

export function useAccountsPayableReport() {
  return useMutation(getQuestReportAccountsPayable, {
    onSuccess() {
      notification.success({
        message: 'Relatório de contas a pagar gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
